import React from 'react';

import {
  Box,
  Column,
  Row,
  SkeletonLoader,
} from '@chargify/custom-ui-components';

export const PaymentProfilesSkeletonLoader = () => (
  <>
    <Row>
      <Column span={[24, 24, 6]}>
        <SkeletonLoader />
      </Column>
      <Column span={[24, 24, 18]}>
        <SkeletonLoader height={180} width={320} />
      </Column>
    </Row>
    <Box marginTop={8}>
      <Row>
        <Column span={[24, 24, 6]}>
          <SkeletonLoader />
        </Column>
        <Column span={[24, 24, 18]}>
          <SkeletonLoader height={180} />
        </Column>
      </Row>
    </Box>
  </>
);
